/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable no-param-reassign */
import * as _ from 'lodash';

function medliTermData(state, languageCode) {
  let data = _.assign({}, state);

  return {
    convertToSearchTerm: () => ({
      id: data.id,
      string: data.strings[languageCode],
    }),
    needsLocalization: () => false,
    formattedTermName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(state, 'strings', {})[code];
    },
    canonicalName: (forceLanguageCode) => {
      const code = forceLanguageCode || languageCode;
      return _.get(state, 'canonical_strings', {})[code] || '';
    },
    set: (medliData) => { data = medliData; },
  };
}

class MedliTerm {
  set(data) {
    Object.keys(data).forEach((key) => {
      this[key] = data[key];
    });
  }
}

function createMedliTerm(initialData, languageCode) {
  const state = _.assign({}, initialData);

  const medliTerm = new MedliTerm();
  medliTerm.set(
    _.assign({}, {
      id: state.id,
      data: () => state,
    }, medliTermData(state, languageCode))
  );

  return medliTerm;
}

export default createMedliTerm;
